class Sticky {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        this.fixElement();
    }

    fixElement() {
        this.el.style.setProperty("--true-height", this.el.offsetHeight + "px");
        this.el.style.setProperty("--true-width", this.el.offsetWidth + "px");

        window.addEventListener("scroll", () => {
            const elementTop = this.el.getBoundingClientRect().top;

            if (elementTop <= 0) {
                this.el.classList.add("stuck");
            } else {
                this.el.classList.remove("stuck");
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const stickyElements = document.querySelectorAll("[data-sticky]");

    stickyElements.forEach((element) => {
        new Sticky(element);
    });
});
